import {
  Button,
  Box,
  TextField,
  Typography,
} from '@mui/material';

import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { EmailVerificationRequest } from '../../../services/authentication.types';
import { emailVerificationSchema } from '../../../validation/schemas/emailVerificationSchema';
import EmailSent from '../Confirmations/EmailSent';
import api from '../../../services/api';

function VerifyEmail({ forgotPassword = false, changeEmail = false }) {
  // variables
  const [isEmailSent, setIsEmailSent] = useState(false);

  // form
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm<EmailVerificationRequest>({
    mode: 'onSubmit',
    resolver: yupResolver(emailVerificationSchema),
    criteriaMode: 'all',
    defaultValues: {
      email: '',
    },
  });

  // functions
  const onRegisterNewUserConfirm = handleSubmit(async () => {
    api.post('/auth/verify/register-email', {
      email: getValues('email'),
    }).then(() => {
      setIsEmailSent(true);
    }).catch((error) => {
      errors.email = {
        type: 'server',
        message: error.response.data.message,
      };
    });
  });

  const onForgotPasswordConfirm = handleSubmit(async () => {
    api.post('/auth/forgot-password', {
      email: getValues('email'),
    }).then(() => {
      setIsEmailSent(true);
    }).catch((error) => {
      errors.email = {
        type: 'server',
        message: error.response.data.message,
      };
    });
  });

  const onChangeEmailConfirm = handleSubmit(async () => {
    api.post('/v1/users/send-email-change', {
      email: getValues('email'),
    }).then(() => {
      setIsEmailSent(true);
    }).catch((error) => {
      errors.email = {
        type: 'server',
        message: error.response.data.message,
      };
    });
  });

  // render conditions
  if (isEmailSent) {
    return <EmailSent forgotPassword={forgotPassword} changeEmail={changeEmail} />;
  }

  return (
    <>
      <Helmet>
        <title>
          {(forgotPassword && 'Password reset') || (changeEmail && 'Change email address') || (!forgotPassword && !changeEmail && 'Registration')}
          - BUILD-SELF
        </title>
      </Helmet>
      <main className="d-flex w-100 h-100 login-background">
        <div className="container d-flex flex-column">
          <div className="vh-100">
            <div className="mx-auto d-table h-100 w-50">
              <div className="d-table-cell align-middle">
                <Box className="text-center my-4" sx={{ width: '100%' }}>
                  <img
                    className="img-fluid mb-4"
                    width="180"
                    height="48"
                    src="/img/logo.png"
                    alt="BUILD-SELF"
                  />
                  <Box>
                    <h1 className="mb-2 fw-bold">
                      {forgotPassword && 'Password reset'}
                      {changeEmail && 'Change email address'}
                      {!forgotPassword && !changeEmail && 'Registration'}
                    </h1>
                  </Box>
                  <Box>
                    <Typography
                      fontSize={12}
                    >
                      {forgotPassword && 'A password reset URL will be sent to your registered email.'}
                      {changeEmail && 'An email will be sent to change your email address.'}
                      {!forgotPassword && !changeEmail && 'A verification email will be sent to the email address you entered.'}
                    </Typography>
                  </Box>
                </Box>

                <Box className="card">
                  <Box className="card-body">
                    <label className="form-label w-100">
                      Email address
                    </label>
                    <TextField
                      {...register('email')}
                      placeholder="mail@build-self.com"
                      variant="outlined"
                      size="small"
                      error={!!errors.email}
                      helperText={errors.email?.message || ' '}
                      fullWidth
                    />

                    <Button
                      onClick={(forgotPassword && onForgotPasswordConfirm)
                        || (changeEmail && onChangeEmailConfirm)
                        || onRegisterNewUserConfirm}
                      variant="contained"
                      className="w-100"
                    >
                      Send email
                    </Button>
                  </Box>
                </Box>
                {/* <div className="version mt-1 mx-1">version 0.0.1</div> */}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default VerifyEmail;
